/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureLabelKind } from './CaptureLabelKind';
import {
    CaptureLabelKindFromJSON,
    CaptureLabelKindFromJSONTyped,
    CaptureLabelKindToJSON,
    CaptureLabelKindToJSONTyped,
} from './CaptureLabelKind';

/**
 * 
 * @export
 * @interface CaptureLabelSchema
 */
export interface CaptureLabelSchema {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    kind: CaptureLabelKind;
    /**
     * 
     */
    category: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description: string | null;
}



/**
 * Check if a given object implements the CaptureLabelSchema interface.
 */
export function instanceOfCaptureLabelSchema(value: object): value is CaptureLabelSchema {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CaptureLabelSchemaFromJSON(json: any): CaptureLabelSchema {
    return CaptureLabelSchemaFromJSONTyped(json, false);
}

export function CaptureLabelSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureLabelSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'kind': CaptureLabelKindFromJSON(json['kind']),
        'category': json['category'],
        'name': json['name'],
        'description': json['description'],
    };
}

export function CaptureLabelSchemaToJSON(json: any): CaptureLabelSchema {
    return CaptureLabelSchemaToJSONTyped(json, false);
}

export function CaptureLabelSchemaToJSONTyped(value?: CaptureLabelSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'kind': CaptureLabelKindToJSON(value['kind']),
        'category': value['category'],
        'name': value['name'],
        'description': value['description'],
    };
}

